(function () {
  function readData(root) {
    try {
      return JSON.parse(root.querySelector('[data-lf-dd-data]').textContent);
    } catch (e) {
      return null;
    }
  }

  function renderSeason(root, engine, data, state) {
    var parts = engine.seasonMessage(data.rules, state);
    root.querySelectorAll('[data-lf-dd-season]').forEach(function (row) {
      var out = row.querySelector('[data-lf-dd-season-text]');
      if (!parts || !out) {
        row.hidden = true;
        return;
      }
      out.textContent = '';
      parts.forEach(function (part) {
        var span = document.createElement('span');
        if (part.strong) span.className = 'font-semibold text-grey-900';
        span.textContent = part.text;
        out.appendChild(span);
      });
      row.hidden = false;
    });
  }

  // PostHog starts only after Shopify's consent check (UK: once the visitor accepts), usually after this runs; until then window.posthog has no capture.
  function track(name, props, tries) {
    var ph = window.posthog;
    if (ph && typeof ph.capture === 'function') return ph.capture(name, props);
    if ((tries || 0) < 240) setTimeout(function () { track(name, props, (tries || 0) + 1); }, 500);
  }

  // quiet = a timer refresh, so the parity event isn't sent again.
  function render(root, data, variantId, quiet) {
    var engine = window.LfDeliveryDates;
    var extra = data.variantExtraDays[String(variantId)] || 0;
    var variant = (data.variantOption || {})[String(variantId)] || '';
    var items = [{ productType: data.productType, makeDays: data.makeDays, extraDays: extra, variant: variant }];
    var now = new Date();
    var shown = [];

    var dispatch = engine.estimate(data.rules, items, { now: now });
    if (!dispatch) {
      root.querySelectorAll('[data-lf-dd-date]').forEach(function (el) { el.textContent = ''; });
      root.querySelectorAll('[data-lf-dd-show], [data-lf-dd-season]').forEach(function (el) { el.hidden = true; });
      return null;
    }
    // Arrival dates only for countries the rules deliver to (dispatch is the same everywhere).
    var region = data.country || undefined;
    var season = engine.seasonState(data.rules, data.seasons || [], items, { now: now, region: region });

    root.querySelectorAll('[data-lf-dd-date]').forEach(function (el) {
      var method = el.getAttribute('data-method');
      var res = method === 'fastest' ? engine.fastest(data.rules, items, { now: now, region: region })
        : method ? engine.estimate(data.rules, items, { now: now, method: method, region: region }) : dispatch;
      var ymd = res && (method ? res.deliveryDate : res.dispatchDate);
      if (method && engine.hidesForSeason(season, (res && res.method) || method, ymd)) ymd = null;
      el.textContent = ymd ? engine.formatDate(data.rules, ymd, el.getAttribute('data-style') || 'long') : '';
      // Rows are grid items, where the hidden attribute loses to the display class.
      var row = el.closest('[data-lf-dd-row]');
      if (row) row.style.display = ymd ? '' : 'none';
      if (ymd) shown.push({ method: (res.method || method) || 'dispatch', date: ymd });
    });
    root.querySelectorAll('[data-lf-dd-property]').forEach(function (input) {
      input.value = engine.formatDate(data.rules, dispatch.dispatchDate, 'property');
    });
    renderSeason(root, engine, data, season);
    root.querySelectorAll('[data-lf-dd-show]').forEach(function (el) {
      el.hidden = shown.length === 0;
    });

    // Feeds the parity check: the same product must never be shown two dates on one day across surfaces.
    if (!quiet) {
      shown.forEach(function (s) {
        track('delivery_estimate_shown', {
          surface: root.getAttribute('data-surface'),
          market: data.rules.market,
          product_id: data.productId,
          variant_id: variantId,
          method: s.method,
          date: s.date,
          engine_version: dispatch.engineVersion
        });
      });
    }
    return season;
  }

  function init(root) {
    if (root.__lfDdInit || !window.LfDeliveryDates) return;
    var data = readData(root);
    if (!data) return;
    data.rules = Object.assign({}, data.rules, { productTypes: data.productTypes || {} });
    root.__lfDdInit = true;
    var variantId = data.variantId;
    render(root, data, variantId);
    // Cut-offs, deadlines and countdowns pass while the page is open, so recompute each minute.
    setInterval(function () { render(root, data, variantId, true); }, 60000);
    document.addEventListener('cc-variant-updated', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.id && Object.prototype.hasOwnProperty.call(data.variantExtraDays, String(v.id))) {
        variantId = v.id;
        render(root, data, variantId);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lf-dd]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
